export interface StepGuideProps {
  image: string
  title: string
  content: string
}

export default function StepGuide({ image, title, content }: StepGuideProps) {
  return (
    <div className='bg-sunshine-yellow p-4 flex flex-col gap-3'>
      <img src={image} alt={title} className='w-full object-cover aspect-video rounded-md' />
      <h3 className='font-serif font-bold text-2xl text-black text-center'>{title}</h3>
      <p className='font-sans text-sm text-black text-center leading-relaxed'>{content}</p>
    </div>
  )
}
